'use strict';

// Service for getting the cookie and polyfill

angular.module('storyApp').factory('trackingUtils', function() {
(function () {
           function CustomEvent ( event, params ) {
           params = params || { bubbles: false, cancelable: false, detail: undefined };
           var evt = document.createEvent( 'CustomEvent' );
           evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
           return evt;
           }
           CustomEvent.prototype = window.Event.prototype;

           window.CustomEvent = CustomEvent;
           })();

     function readCookie(name) {
         var nameEQ = name + "=";
         var ca = document.cookie.split(';');
         for(var i=0;i < ca.length;i++) {
           var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    function sendThreeThingsData(data) {
    	//Hotfix for 3 things
    	var dataLength = data.response.docs.length;
    	dataLength = dataLength > 3 ? 3 : dataLength;
    	var docidArray = "[";
    	for (var i = 0; i < dataLength; i++) {
    	    if (i != 0) docidArray += ",";
    	    docidArray += data.response.docs[i].docid;
    	}
    	docidArray += "]";
    	
       var impEvent =new CustomEvent('three_things',{detail:{

	   type:"impression",

	   userexp:"relevantRelated",

	   docid:docidArray,

       uuid:readCookie('AMCV_5BFD123F5245AECB0A490D45%40AdobeOrg')


     }});

        var cookieValue = impEvent.detail.uuid;
        var pattern = "MCMID%7C";

        if (!cookieValue){
            delete impEvent.detail.uuid;
        } else {
            impEvent.detail.uuid = cookieValue.substring(cookieValue.indexOf(pattern) + pattern.length , cookieValue.indexOf(pattern) + pattern.length +38);
        }

        setTimeout(function(){ document.dispatchEvent(impEvent); }, 2000);

    }

    function sendThreeThingsClickedData(data, relatedIndex){

        var clkEvent =new CustomEvent('three_things',{detail:{
	    type:"click",
	    userexp:"relevantRelated",
	    docid:data[relatedIndex].docid,
        uuid:readCookie('AMCV_5BFD123F5245AECB0A490D45%40AdobeOrg')    

    }});
         var cookieValue = clkEvent.detail.uuid;
        var pattern = "MCMID%7C";

        if (cookieValue == ""){

            delete clkEvent.detail.uuid;
        }

        else {

          clkEvent.detail.uuid = cookieValue.substring(cookieValue.indexOf(pattern) + pattern.length , cookieValue.indexOf(pattern) + pattern.length +38);
        }
        document.dispatchEvent(clkEvent);


    }
return {

    readCookie : readCookie,
    sendThreeThingsData : sendThreeThingsData,
    sendThreeThingsClickedData : sendThreeThingsClickedData

}
 });



// WEBPACK FOOTER //
// ./assets/components/threethings/factories/trackingUtils.js